import { useSessionOrNull } from '~/contexts/SessionContext';
import { createImageReferencesView } from '~/domain/projections/factories';
import { ImageReferenceView } from '~/domain/projections/views';
import { useDomainProjection } from './useDomainProjection';

const NO_ITEMS: readonly ImageReferenceView[] = [];

/**
 * Subscribe to the objects that reference an image: structure sets,
 * registrations and doses, for the image details dialog. Returns an empty
 * list when there is no active session; the dialog can open from lists
 * that mount before PatientSessionProvider's effect creates one.
 *
 * A missing Frame of Reference only withholds the objects looked up by
 * frame: the structure sets are matched by series and stay listed.
 */
export function useImageReferencesView(
    seriesUid: string | undefined,
    frameOfReferenceUid: string | undefined
): readonly ImageReferenceView[] {
    const forUid = frameOfReferenceUid ?? '';
    return useDomainProjection(
        useSessionOrNull(),
        'useImageReferencesView',
        [seriesUid, forUid],
        (patient) =>
            seriesUid
                ? createImageReferencesView(patient, seriesUid, forUid)
                : NO_ITEMS,
        NO_ITEMS
    );
}
